import { __awaiter } from "tslib";
import { InterconsultService } from "@/services/models/interconsult/interconsult";
const moduleInterconsultsWithAppointment = {
    namespaced: true,
    state: {
        loading: false,
        tableInterconsultWithAppointment: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        filterInterconsults: {
            state: "",
            step: "",
            node: 0,
            step2: "",
            service_node_id: null,
            ges: null,
            state_citation: "agendado",
            patient_id: null,
            is_cosam: false,
            patient_rut: null,
        },
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getTableInterconsultWithAppointment(state) {
            return state.tableInterconsultWithAppointment;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTableInterconsultWithAppointment(state, tableInterconsultWithAppointment) {
            state.tableInterconsultWithAppointment = tableInterconsultWithAppointment;
        },
        setPagTableInterconsultWithAppointment(state, page) {
            state.tableInterconsultWithAppointment.current_page = page;
        },
        setTableInterconsultWithAppointmentFilter(state, filter) {
            state.filterInterconsults.state = filter.state;
            state.filterInterconsults.step = filter.step_destino;
            state.filterInterconsults.node = filter.node;
            state.filterInterconsults.step2 = filter.step_origen;
            state.filterInterconsults.diagnostic = filter.diagnostic;
            state.filterInterconsults.request_date_end = filter.request_date_end;
            state.filterInterconsults.request_date_start = filter.request_date_start;
            state.filterInterconsults.origin_node_id = filter.origin_node_id;
            state.filterInterconsults.service_node_id = filter.service_node_id;
            state.filterInterconsults.priority = filter.priority;
            state.filterInterconsults.ges = filter.ges;
            state.filterInterconsults.is_cosam = filter.is_cosam;
            if (filter.patient_rut) {
                state.filterInterconsults.patient_rut = filter.patient_rut.replaceAll(".", "").replaceAll("-", "");
            }
        },
        cleanTableInterconsultWithAppointmentFilter(state) {
            state.filterInterconsults.state = null;
            state.filterInterconsults.step = null;
            state.filterInterconsults.node = null;
            state.filterInterconsults.step2 = null;
            state.filterInterconsults.diagnostic = null;
            state.filterInterconsults.request_date_end = null;
            state.filterInterconsults.request_date_start = null;
            state.filterInterconsults.origin_node_id = null;
            state.filterInterconsults.priority = null;
            state.filterInterconsults.ges = null;
            state.filterInterconsults.service_node_id = null;
            state.filterInterconsults.is_cosam = null;
            state.filterInterconsults.patient_rut = null;
        },
        setTableInterconsultWithAppointmentService(state, service_node_id) {
            state.filterInterconsults.service_node_id = service_node_id;
        },
        setTableInterconsultWithAppointmentGes(state, ges) {
            state.filterInterconsults.ges = ges;
        },
        setTableInterconsultWithAppointmentStateCitation(state, state_citation) {
            state.filterInterconsults.state_citation = state_citation;
        },
        setTableInterconsultWithAppointmentPatient(state, patient_id) {
            state.filterInterconsults.patient_id = patient_id;
        },
    },
    actions: {
        getTableInterconsultWithAppointment({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const INTERCONSULTS = yield InterconsultService.getFindByStateStepNodeHaveicPost(state.filterInterconsults, state.tableInterconsultWithAppointment.current_page);
                commit("setTableInterconsultWithAppointment", INTERCONSULTS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleInterconsultsWithAppointment;
